<template>
    <div class="bax-drug-patient-list">
        <div class="bax-drug-patient-summary d-md-flex align-items-center">
            <div v-if="patient.firstName.length + patient.lastName.length !== 0" class="bax-patient-name">
                Patient Name
              <h3>{{ patient.firstName || patient.lastName ? patient.firstName + ' ' + patient.lastName : '--' }}</h3>
            </div>
            <div v-else class="bax-patient-name">
                <h3>No patient name</h3>
            </div>
            <div v-if="patient.firstName.length + patient.lastName.length !== 0" class="bax-patient-summary ml-auto mt-3 mt-md-0">
                <ul class="text-md-right">
                    <li>Patient ID : <strong>{{ patient.baxterPatientId }}</strong></li>
                    <li>Date of Birth : <strong>{{ patient.dateOfBirth }}</strong></li>
                </ul>
            </div>
        </div>
        <div class="bax-collapse" v-if="open === false">
            <div class="bax-collapse-header">
                <a href="#" class="bax-btn bax-btn-white" @click.prevent="open = true">
                    <i class="icon-chevron-down"></i>View details
                </a>
            </div>
        </div>
        <div class="bax-patient-drug-list" v-if="open === true">
            <ul>
                <li v-for="(drug, index) in patient.drugs" :key="index">
                    <patient-summary-drug-info :drug="drug" @removeDrug="$emit('removeDrug', drug)"></patient-summary-drug-info>
                </li>
            </ul>
        </div>
        <div class="bax-collapse" v-if="open === true">
            <div class="bax-collapse-header bax-collapse-active">
                <a href="#" class="bax-btn bax-btn-white" @click.prevent="open = false">
                    <i class="icon-chevron-up"></i>Hide details
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import PatientSummaryDrugInfo from './PatientSummaryDrugInfo.vue';

export default {
    name: 'PatientSummary',
    components: {
        PatientSummaryDrugInfo,
    },
    props: {
        patient: {},
    },
    data() {
        return {
            open: false,
        };
    },
    methods: {
        selectPatient(patient) {
            this.$emit('patientSelect', patient);
        },
    },
};
</script>

<style scoped>
.bax-drug-patient-list {
    cursor: pointer;
    user-select: none;
}
.patient-selcted {
    border: 1px solid red !important;
}
</style>
